import {CropFamilyId} from '../../features/tool/resources/cropFamilies';
import Eucalyptus1 from './eucalyptus/01.json';
import Eucalyptus2 from './eucalyptus/02.json';
import Eucalyptus3 from './eucalyptus/03.json';
import Eucalyptus4 from './eucalyptus/04.json';
import Hemp1 from './hemp/01.json';
import Hemp2 from './hemp/02.json';
import Hemp3 from './hemp/03.json';
import Hemp4 from './hemp/04.json';
import Miscanthus1 from './miscanthus/01.json';
import Miscanthus2 from './miscanthus/02.json';
import Miscanthus3 from './miscanthus/03.json';
import Miscanthus4 from './miscanthus/04.json';
import RCG1 from './rcg/01.json';
import RCG2 from './rcg/02.json';
import RCG3 from './rcg/03.json';
import RCG4 from './rcg/04.json';
import SRCPoplar1 from './srcpoplar/01.json';
import SRCPoplar2 from './srcpoplar/02.json';
import SRCPoplar3 from './srcpoplar/03.json';
import SRCPoplar4 from './srcpoplar/04.json';
import SRFPoplar1 from './srfpoplar/01.json';
import SRFPoplar2 from './srfpoplar/02.json';
import SRFPoplar3 from './srfpoplar/03.json';
import SRFPoplar4 from './srfpoplar/04.json';
import Willow1 from './willow/01.json';
import Willow2 from './willow/02.json';
import Willow3 from './willow/03.json';
import Willow4 from './willow/04.json';

const CropAnimations: Record<CropFamilyId, object[]> = {
  [CropFamilyId.miscanthus]: [Miscanthus1, Miscanthus2, Miscanthus3, Miscanthus4],
  [CropFamilyId.srcPoplar]: [SRCPoplar1, SRCPoplar2, SRCPoplar3, SRCPoplar4],
  [CropFamilyId.willow]: [Willow1, Willow2, Willow3, Willow4],
  [CropFamilyId.eucalyptus]: [Eucalyptus1, Eucalyptus2, Eucalyptus3, Eucalyptus4],
  [CropFamilyId.rcg]: [RCG1, RCG2, RCG3, RCG4],
  [CropFamilyId.srfPoplar]: [SRFPoplar1, SRFPoplar2, SRFPoplar3, SRFPoplar4],
  [CropFamilyId.hemp]: [Hemp1, Hemp2, Hemp3, Hemp4],
};

export default CropAnimations;
